import { FeatureDTO } from "./FeatureDTO";

export class CanRegisterFeatureDTO extends FeatureDTO {
    constructor(sub?) {
        super(sub);
    }
}
